// // =============================
// // Dashboard.jsx
// // =============================
// import React, { useState } from "react";
// import {
//   PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer,
//   BarChart, Bar, XAxis, YAxis, CartesianGrid
// } from "recharts";
// import "./Hrmdashbord.css";

// const COLORS = ["#4f46e5", "#22c55e", "#f97316", "#ef4444", "#06b6d4", "#a855f7"]; 

// const summaryCards = [
//   { title: "Total Employee", value: 15 },
//   { title: "Total Onboarding", value: 6 },
//   { title: "Today's New Onboarding", value: 200 },
//   { title: "Employee On Leave", value: 17 },
//   { title: "Late / Missed Logins", value: 9 },
//   { title: "In Time Clock-In", value: 10 },
//   { title: "Notice Period", value: 4 },
//   { title: "Today's Resignation", value: "4+" },
//   { title: "Last Working Day", value: "4+" },
//   { title: "WFO B1", value: 4 },
//   { title: "WFH", value: "4+" },
//   { title: "WFC", value: "4+" }
// ];

// const pieData = [
//   { name: "Business", value: 200 },
//   { name: "IT", value: 150 },
//   { name: "HR", value: 100 },
//   { name: "Finance", value: 80 }
// ];

// const barData = [
//   { dept: "DFS", value: 120 },
//   { dept: "IAS", value: 90 },
//   { dept: "EDS", value: 160 },
//   { dept: "IT", value: 200 }
// ];

// export default function Dashboard() {
//   const [filter, setFilter] = useState("Today");
//   const [year, setYear] = useState(2026);

//   const handleExport = () => {
//     const blob = new Blob([JSON.stringify({ filter, year, summaryCards })], {
//       type: "application/json",
//     });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = "dashboard-data.json";
//     link.click();
//   };

//   return (
//     <div className="dashboard-wrapper">
//       {/* Header */}
//       <div className="dashboard-header">
//         <h2>HR Premium Dashboard</h2>
//         <div className="filters">
//           <select value={filter} onChange={(e) => setFilter(e.target.value)}>
//             <option>Today</option>
//             <option>Week</option>
//             <option>Month</option>
//           </select>
//           <select value={year} onChange={(e) => setYear(e.target.value)}>
//             <option>2024</option>
//             <option>2025</option>
//             <option>2026</option>
//           </select>
//           <button onClick={handleExport}>Export</button>
//           <button className="import-btn">Import</button>
//         </div>
//       </div>

//       {/* Summary Cards */}
//       <div className="summary-grid">
//         {summaryCards.map((item, index) => (
//           <div className="summary-card" key={index}>
//             <p>{item.title}</p>
//             <h3>{item.value}</h3>
//           </div>
//         ))}
//       </div>

//       {/* Charts Section */}
//       <div className="charts-grid">
//         <div className="chart-card">
//           <h4>Employee Distribution</h4>
//           <ResponsiveContainer width="100%" height={300}>
//             <PieChart>
//               <Pie
//                 data={pieData}
//                 dataKey="value"
//                 nameKey="name"
//                 cx="50%"
//                 cy="50%"
//                 outerRadius={100}
//                 innerRadius={60}
//                 label
//               >
//                 {pieData.map((entry, index) => (
//                   <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                 ))}
//               </Pie>
//               <Tooltip />
//               <Legend />
//             </PieChart>
//           </ResponsiveContainer>
//         </div>

//         <div className="chart-card">
//           <h4>Employee Experience Matrix</h4>
//           <ResponsiveContainer width="100%" height={300}>
//             <BarChart data={barData}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="dept" />
//               <YAxis />
//               <Tooltip />
//               <Bar dataKey="value" fill="#4f46e5" radius={[8, 8, 0, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// }



import React, { useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";
import "./Hrmdashbord.css";

const HRM_COLORS = [
  "#4f46e5",
  "#22c55e",
  "#f97316",
  "#ef4444",
  "#06b6d4",
  "#a855f7",
];

const hrmSummaryCards = [
  { title: "Total Employee", value: 15 },
  { title: "Total Onboarding", value: 6 },
  { title: "Today's New Onboarding", value: 200 },
  { title: "Employee On Leave", value: 17 },
  { title: "Late / Missed Logins", value: 9 },
  { title: "In Time Clock-In", value: 10 },
  { title: "Notice Period", value: 4 },
  { title: "Today's Resignation", value: "4+" },
  { title: "Last Working Day", value: "4+" },
  { title: "WFO B1", value: 4 },
  { title: "WFH", value: "4+" },
  { title: "WFC", value: "4+" },
];

const hrmPieData = [
  { name: "Business", value: 200 },
  { name: "IT", value: 150 },
  { name: "HR", value: 100 },
  { name: "Finance", value: 80 },
];

const hrmBarData = [
  { dept: "DFS", value: 120 },
  { dept: "IAS", value: 90 },
  { dept: "EDS", value: 160 },
  { dept: "IT", value: 200 },
];

export default function Dashboard() {
  const [filter, setFilter] = useState("Today");
  const [year, setYear] = useState(2026);

  const handleExport = () => {
    const blob = new Blob(
      [JSON.stringify({ filter, year, hrmSummaryCards })],
      { type: "application/json" }
    );
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "hrm-dashboard-data.json";
    link.click();
  };

  return (
    <div className="hrm-dashboard-wrapper">
      {/* Header */}
      <div className="hrm-dashboard-header">
        <h2>HR Premium Dashboard</h2>

        <div className="hrm-dashboard-filters">
          <select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option>Today</option>
            <option>Week</option>
            <option>Month</option>
          </select>

          <select value={year} onChange={(e) => setYear(e.target.value)}>
            <option>2024</option>
            <option>2025</option>
            <option>2026</option>
          </select>

          <button onClick={handleExport}>Export</button>
          <button className="hrm-import-btn">Import</button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="hrm-summary-grid">
        {hrmSummaryCards.map((item, index) => (
          <div className="hrm-summary-card" key={index}>
            <p>{item.title}</p>
            <h3>{item.value}</h3>
          </div>
        ))}
      </div>

      {/* Charts */}
      <div className="hrm-charts-grid">
        <div className="hrm-chart-card">
          <h4>Employee Distribution</h4>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={hrmPieData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                innerRadius={60}
                label
              >
                {hrmPieData.map((_, index) => (
                  <Cell
                    key={index}
                    fill={HRM_COLORS[index % HRM_COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="hrm-chart-card">
          <h4>Employee Experience Matrix</h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={hrmBarData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="dept" />
              <YAxis />
              <Tooltip />
              <Bar
                dataKey="value"
                fill="#4f46e5"
                radius={[8, 8, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

